import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GenerateUrlComponent } from './generate-url.component';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  {
    path: '',
    component: GenerateUrlComponent,
    data: { title: 'Generar URL para Chat' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class GenerateUrlRoutingModule { }
